import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { currentClientIdSelector } from '../../../../CommonSelectors/CommonAreaSelector';
import { AddAccountButtonsGroup } from '../../../../Profile/Accounts/components/AddAccountPreSelection/components/AddAccountButtonsGroup';
import { usePlaidLink } from '../../../../_hooks/plaid/usePlaidLink';
import { fetchDataIfNecessary } from '../../../AdvWorkflow/AdvWorkflowCacheActions';
import { BACKEND_KEY, BASE_ACCOUNT } from '../../FinancialAccountsWorkflowConstants';
import { setDraftAccount, setViewId } from '../AccountsManualStepActions';
import { ADD, OVERVIEW } from '../AccountsManualStepViews';
import Back from './BackContainer';
import { Wrapper } from './PlaidLinkingStepStyles';
import { setIsPlaidInfoMessageVisibility } from '../../../../Plaid/state/actions';

interface Props {
  workflowId?: string;
  isBackButtonHidden?: boolean;
  className?: string;
}

const PlaidLinkingStep = ({ workflowId, isBackButtonHidden, className }: Props) => {
  const clientId = useSelector(state => currentClientIdSelector(state));

  const dispatch = useDispatch();

  const { open: openPlaid, isLoading } = usePlaidLink({
    clientId,
    onSuccess: async () => {
      await dispatch(
        fetchDataIfNecessary(workflowId, clientId, ['Accounts'], { Accounts: true }, false),
      );
      dispatch(setViewId(OVERVIEW, workflowId));

      dispatch(setIsPlaidInfoMessageVisibility(true));
    },
    onExit: async () => {
      await dispatch(
        fetchDataIfNecessary(workflowId, clientId, ['Accounts'], { Accounts: true }, false),
      );

      dispatch(setViewId(OVERVIEW, workflowId));
    },
  });

  const onManualAddAccountPressed = () => {
    dispatch(setDraftAccount(BASE_ACCOUNT, workflowId));
    dispatch(setViewId(ADD, workflowId));
  };

  return (
    <div id="AccountsLinkingStepWorkflow" className={className}>
      {!isBackButtonHidden && (
        <Back workflowId={workflowId} validationId={`${BACKEND_KEY}.AccountsLinkingSteps`} />
      )}

      <Wrapper>
        <h2 className="accounts-workflow-link-institution-h2">Add your accounts</h2>

        <AddAccountButtonsGroup
          isLoading={isLoading}
          plaidOnClick={() => openPlaid()}
          manualOnClick={() => onManualAddAccountPressed()}
        />
      </Wrapper>
    </div>
  );
};

export default PlaidLinkingStep;
